import React from 'react';
import { StyleSheet, Text } from '../base_components';
import Link from './link';

const styles = StyleSheet.create({
  linkText: { ':hover div': { color: '#06a' } },
  text: { color: 'var(--link-text-color)', textDecoration: 'underline' },
});

type Props = {
  style?: any;
  textStyle?: any;
  url: string;
  text: string;
  target?: any;
};
export default function LinkText(props: Props) {
  const { style, textStyle, ...other_props } = props;
  return (
    <Link style={[styles.linkText, style]} {...other_props}>
      <Text style={[styles.text, textStyle]}>{props.text}</Text>
    </Link>
  );
}
